interface Props {
    showClean?: boolean
    onCleanClick?: () => void
}

export function ButtonSearch({showClean = false, onCleanClick}: Props) {
    return (
        <div className='col w-100 d-flex justify-content-end mb-5'>
            { showClean && onCleanClick !== undefined && 
                <button
                    onClick={() => onCleanClick()}
                    className='btn btn-light px-6 w-auto align-self-end me-2'
                >
                    Limpar
                </button>
            }
            <button
                type='submit'
                className='btn btn-primary px-6 w-auto align-self-end'
            >
                Procurar
            </button>
        </div>
    )
}
